<template lang="pug">

    span
        .ui.mini.labels(v-for='model in variantModels')
            router-link.ui.label(
                v-bind:to='getViewRoute(model)'
                v-tooltip='getPrintingsAsString(model)'
                target="_blank"
            ) V{{ model.number }}

</template>

<script>
    import * as R from 'ramda'

    //noinspection JSUnusedGlobalSymbols
    export default {

        methods: {

            getPrintingsAsString(variantModel) {
                return R.join(', ', R.prop('printings', variantModel))
            },

            getViewRoute(variantModel) {
                return {
                    name: 'products/view',
                    params: {
                        id: variantModel.product,
                        variantId: variantModel.id
                    }
                }
            },

        },

        props: {

            variantModels: {
                type: Array,
                required: true
            }

        }

    }

</script>

<style scoped>

    .ui.labels {
        display: inline;
        white-space: nowrap;
    }

</style>
